<ng-template #templateEditAdd>
    <form [formGroup]="addSchoolYearForm" (ngSubmit)="onSubmit()">
        <div class="col-lg-12">
            <input type="hidden" [formGroup]="addSchoolYearForm" formControlName="id" />
            <div class="form-group">
                <h5><label for="tipoFinanziamento" class="mandatory">Fonte finanziamento:</label></h5>
                <input [formGroup]="addSchoolYearForm" formControlName="tipoFinanziamento" maxlength="255" type="text" value="" class="form-control" placeholder="Inserisci la fonte di finanziamento" [ngClass]="{
                    'form-control': true,
                    'is-invalid': submitted && f.tipoFinanziamento.errors
                    }" />
                <div *ngIf="submitted && f.tipoFinanziamento.errors" class="invalid-feedback" style="display: block;">
                    <div *ngIf="f.tipoFinanziamento.errors.required">
                        Campo obbligatorio
                    </div>
                </div>
            </div>
        </div>


        <div class="col-lg-12 mb-3"><button class="btn btn-lg btn-primary btn-block" type="submit">
            {{buttonLabel}} 
        </button></div>
    </form>
</ng-template>
<div class="container sfondo_bianco">
    <hr />
    <accordion [isAnimated]="true">
        <accordion-group heading="Inserisci Nuova Fonte finanziamento">
            <ng-container *ngTemplateOutlet="templateEditAdd"></ng-container>
        </accordion-group>
    </accordion>
    <div class="mt-5">

        <ngx-datatable-wrapper #ngxDatatableWrapper [templates]="templateList" style="width: 100%; height: auto;" [dtOptions]="dtOptions">
            <ng-template #btnEditTemplate let-row="row" let-value="value">
                <a [ngClass]="{
        'disabled': loading
        }" class=" border-0 text-center" (click)="onEdit(row)" data-toggle="tooltip" data-placement="top" title="modifica dati">&nbsp;&nbsp;&ensp;<i class="far fa-edit pointer"></i></a>
            </ng-template>
            <ng-template #btnDeleteTemplate let-row="row" let-value="value">
                <a [ngClass]="{
        'disabled': loading
        }" class=" border-0 text-center" (click)="onDelete(row)" data-toggle="tooltip" data-placement="top" title="elimina">&nbsp;&nbsp;&ensp;<i class="far fa-trash-alt pointer"></i></a>
            </ng-template>
        </ngx-datatable-wrapper>
    </div>
</div>
<ng-template #templateModal>
    <div class="modal-header  text-center">
        <h4 class="modal-title pull-left">Modifica fonte di finanziamento</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
    </div>
    <div class="modal-body">
        <ng-container *ngTemplateOutlet="templateEditAdd"></ng-container>
    </div>
</ng-template>